import * as Yup from 'yup';

export const ContactModalValidationSchema = () =>
	Yup.object().shape({
		email: Yup.string().email().required('E-mail is required.'),
		phone: Yup.string().required('Phone number is required.'),
	});
